import 'css-chunksrc/client/scenes/projectReportSubmission/styles.scss';export default {
  "header": "_header_1glpu_1",
  "projectReportSubmission": "_projectReportSubmission_1glpu_5",
  "main": "_main_1glpu_13",
  "group": "_group_1glpu_24",
  "subTitle": "_subTitle_1glpu_28",
  "input": "_input_1glpu_34",
  "button": "_button_1glpu_44",
  "footer": "_footer_1glpu_65"
};